export const ClickTypes = {
  Link: "link",
  Icon: "icon",
  Image: "image",
  Text: "text",
  Interaction: "inteaction",
  Expand: "expand",
  Collapse: "collapse",
  Click: "click",
  Swipe: "swipe",
} as const;

export const interactiveElementsComponentsNames = {
  AUTOPLAY_CAROUSEL: "AutoplayCarousel",
  FAQS: "Faqs",
  FAQSV2: "FaqsV2",
  ROTATING_TEXT_BUTTON: "Rotating Text Button",
  SINGLE_SLIDER: "SingleSlider",
  SLIDER: "Slider",
  TRUSTPILOT: "Trustpilot",
  TRUSTPILOTV2: "TrustpilotV2",
  VIDEO_DIALOGUE: "Video Dialogue",
  TRUSTPILOT_REVIEWS_WIDGET_GRID: "TrustpilotReviewsWidgetGrid",
  COST_CALCULATOR: "CostCalculator",
} as const;

export const navigationComponentsNames = {
  NAVBAR: "Navbar",
  LINK: "Link",
  BUTTON: "Button",
  ICON_BUTTON: "IconButton",
} as const;

export const textVariants = [
  "text-1",
  "text-2",
  "text-3",
  "text-4",
  "text-5",
  "text-6",
  "label",
] as const;

export const textColors = [
  "blue",
  "beige",
  "green",
  "white",
  "gray",
  "primary",
  "primary-inverted",
  "secondary",
  "disclaimer",
  "action",
  "success",
  "success-highlight",
  "warning",
  "warning-highlight",
  "danger",
  "danger-highlight",
  "info",
  "info-highlight",
  "disabled",
] as const;
